import { createTheme } from "@mui/material";

export const theme = createTheme({
    palette:{
        secondary:{
            main:"#8e24aa",
        }
    }
})